import ToolsFooter from '../ToolsFooter';
import { ToolsAndServiceTemplateCode } from '../codeHighlights/ToolsAndServiceTemplateCode';
import ToolsHeaderDemo from '../nav/ToolsHeaderDemo';

const ToolsAndServicesTemplate = () => {
  return (
    <>
      <ToolsHeaderDemo />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1>Title</h1>
            <p className="lead">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta
              magni incidunt quos ex! Veniam accusamus ad harum suscipit ipsa,
              voluptas ipsum eligendi quisquam quis aspernatur iure. Nisi sequi
              esse eveniet.
            </p>
          </div>
        </div>
        <ToolsFooter />
      </div>
      <div className="mt-5">
        <ToolsAndServiceTemplateCode />
      </div>
    </>
  );
};

export default ToolsAndServicesTemplate;
